<span *ngIf="state.conditionText" [title]="state.conditionText">{{ state.conditionText }}</span>
<span *ngIf="state.expandToSee">(Expand to see)</span>
